import { useMemo } from "react";

import { useStorefrontTenant } from "context/StorefrontTenantContext";
import {
  getStorefrontCopyValue,
  normalizeStorefrontLocale,
  storefrontCopyForTenant,
} from "lib/storefrontCopy";
import { getTextLocale } from "lib/storefront";

export default function useStorefrontCopy() {
  const { tenant, tenantKey } = useStorefrontTenant();
  const locale = useMemo(() => {
    if (tenantKey === "mx") return "es-MX";
    const fromTenant = normalizeStorefrontLocale(tenant?.defaultLocale);
    if (fromTenant && tenantKey) return fromTenant;
    return getTextLocale();
  }, [tenant?.defaultLocale, tenantKey]);
  const copy = useMemo(
    () => storefrontCopyForTenant(tenant, locale),
    [tenant, locale]
  );

  return useMemo(
    () => ({
      copy,
      locale,
      t: (path, fallback = "") => getStorefrontCopyValue(copy, path, fallback),
    }),
    [copy, locale]
  );
}
